import React from 'react';
import { Form as FormBootstrap } from 'react-bootstrap';
import AddHeader from '../../../../components/layout/header/add';
import Form from '../../../../components/molecules/forms';
import { SERVICE_REASON_OPTIONS } from '../../../../components/atoms/const';
import FormFooter from '../../../../components/layout/footer/form';
import { LineStroke } from '../../../../components/atoms/icons';
import useAddService from './hooks';
import Button from '../../../../components/molecules/buttons';

function AddService() {
  const {
    formik, client, vm, addServiceLoad, navigateToLanding,
  } = useAddService();
  return (
    <div>
      <AddHeader
        primary={{ route: '/customer-support', title: 'Service Request' }}
        title="Add Service Request"
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-16 mb-4">Service Request Details</div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="serviceReason"
                placeholder="Service Reason"
                label="Choose Service Reason"
                options={SERVICE_REASON_OPTIONS}
                isSearchable={false}
                value={formik.values.serviceReason}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('serviceReason', e);
                  }
                }}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.serviceReason && formik.touched.serviceReason}
                errorMsg={formik.errors.serviceReason}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="clientName"
                placeholder="Client Name"
                label="Search or Choose A Client"
                options={client.list}
                value={formik.values.clientName}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('clientName', e);
                    formik.setFieldValue('vmId', null);
                  }
                }}
                onBlur={formik.handleBlur}
                disabled={client.load}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.ReactSelect.Default
                id="vmId"
                placeholder="Vending Machine"
                label="Choose Vending Machine"
                isSearchable={false}
                options={vm.list}
                value={formik.values.vmId}
                onChange={(e) => {
                  if (e) {
                    formik.setFieldValue('vmId', e);
                  }
                }}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.vmId && formik.touched.vmId}
                errorMsg={formik.errors.vmId}
                disabled={!formik.values.clientName}
              />
            </div>
          </div>
          <Form.Default
            id="comment"
            label="Notes (Optional)"
            placeholder="Enter Notes"
            as="textarea"
            className="mb-4"
            rows={4}
            value={formik.values.comment}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="firstname"
                placeholder="Enter First Name"
                label="First Name (Optional)"
                value={formik.values.firstname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="lastname"
                placeholder="Enter Last Name"
                label="Last Name (Optional)"
                value={formik.values.lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Form.Default
                id="email"
                placeholder="Enter Email Address"
                label="Email Address (Optional)"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.email && formik.touched.email}
                errorMsg={formik.errors.email}
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="phoneNumber"
                placeholder="Enter Phone Number"
                label="Phone Number (Optional)"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
        </div>
        <div style={{ paddingLeft: 20 }}>
          <FormBootstrap.Check
            id="sms"
            label="Send me a message"
            type="checkbox"
            className="ms-4 ms-xl-5 label"
            checked={formik.values.sms}
            onChange={(e) => {
              if (e) formik.setFieldValue('sms', e.target.checked);
            }}
            disabled={formik.values.phoneNumber === ''}
          />
        </div>
        <LineStroke height={7} />
        <div className="d-flex justify-content-end p-4 px-xl-5">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              onClick={navigateToLanding}
              outline
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="submit"
              type="submit"
              label="Add"
              size="lg"
              loading={addServiceLoad}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddService;
